export default __webpack_public_path__ + "static/media/chuseok3.ee8e7f26.jpg";